/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import BenefitsPanel from '../components/BenefitsPanel';
import BioPage from '../components/BioPage';
import BlockFull from '../components/BlockFull';
import BlockSplit from '../components/BlockSplit';
import CasePage from '../components/CasePage';
import Component from '../components/Component';
import ContactPage from '../components/ContactPage';
import ErrorPage from '../components/ErrorPage';
import FeaturedClients from '../components/FeaturedClients';
import GridSix from '../components/GridSix';
import GridSixItem from '../components/GridSixItem';
import HappyPanel from '../components/HappyPanel';
import JobListPanel from '../components/JobListPanel';
import LogoLinks from '../components/LogoLinks';
import MarketPage from '../components/MarketPage';
import ScrollLeft from '../components/ScrollLeft';
import ScrollPage from '../components/ScrollPage';
import ScrollRight from '../components/ScrollRight';
import SeoPage from '../components/SeoPage';
import ServiceDetail from '../components/ServiceDetail';
import ServicePage from '../components/ServicePage';
import SiteMap from '../components/SiteMap';
import StandardPage from '../components/StandardPage';
import StaticPanel from '../components/StaticPanel';
import StaticScrollPage from '../components/StaticScrollPage';
import StaticSlider from '../components/StaticSlider';
import TeamGrid from '../components/TeamGrid';
import TeamPage from '../components/TeamPage';
import TextColumns from '../components/TextColumns';
import WorkItem from '../components/WorkItem';
import WorkPage from '../components/WorkPage';

const components = new Map();
components.set('BenefitsPanel', BenefitsPanel);
components.set('BioPage', BioPage);
components.set('BlockFull', BlockFull);
components.set('BlockSplit', BlockSplit);
components.set('CasePage', CasePage);
components.set('Component', Component);
components.set('ContactPage', ContactPage);
components.set('ErrorPage', ErrorPage);
components.set('FeaturedClients', FeaturedClients);
components.set('GridSix', GridSix);
components.set('GridSixItem', GridSixItem);
components.set('HappyPanel', HappyPanel);
components.set('JobListPanel', JobListPanel);
components.set('LogoLinks', LogoLinks);
components.set('MarketPage', MarketPage);
components.set('ScrollLeft', ScrollLeft);
components.set('ScrollPage', ScrollPage);
components.set('ScrollRight', ScrollRight);
components.set('SeoPage', SeoPage);
components.set('ServiceDetail', ServiceDetail);
components.set('ServicePage', ServicePage);
components.set('SiteMap', SiteMap);
components.set('StandardPage', StandardPage);
components.set('StaticPanel', StaticPanel);
components.set('StaticScrollPage', StaticScrollPage);
components.set('StaticSlider', StaticSlider);
components.set('TeamGrid', TeamGrid);
components.set('TeamPage', TeamPage);
components.set('TextColumns', TextColumns);
components.set('WorkItem', WorkItem);
components.set('WorkPage', WorkPage);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
